import React from 'react';

import { NikeRoute } from 'nike-ui/src/common/routing/types';

import { TabButton } from '@/header/HeaderTabsContainer';
import useHeaderTabsScroll from '@/_hooks/useHeaderTabsScroll';
import {
    SCRATCHCARD_KIOSK_LIST,
    SCRATCHCARD_OVERVIEW,
    SCRATCHCARD_CONTACT,
    SCRATCHCARD_FAQ,
    SCRATCHCARD_PARTNER_ZONE
} from '@/routing/routes';

import { useLotteryData } from 'nike-ui/src/components/lottery/common';

import '@/header/HeaderTabsContainer.less';

/**
 * The API is object with keys (unordered), so we define the order
 */
const ROUTE_TABS = [
    SCRATCHCARD_OVERVIEW,
    SCRATCHCARD_KIOSK_LIST,
    SCRATCHCARD_PARTNER_ZONE,
    SCRATCHCARD_FAQ,
    SCRATCHCARD_CONTACT
];

/**
 * Resolves label of the tab navigation menu based on API
 * @param path
 */
const resolveTabLabel = (path: string, navi: Record<string, any>[]) => {
    const result = navi.find(e => e.path === path);
    return result.label;
};

interface NavTabsProps {
    active: NikeRoute;
}

const NavTabs: React.FC<NavTabsProps> = ({ active }) => {
    const scrollElementRef = useHeaderTabsScroll();
    const { isLoading, data, isError } = useLotteryData();

    if (isLoading || isError) {
        return null;
    }

    return (
        <div className="specific-navbar-tabs page-header-tabs">
            {ROUTE_TABS.map((route, idx) => (
                // @ts-expect-error missing typings
                <TabButton key={idx} route={route} activeRoute={active} scrollElementRef={scrollElementRef}>
                    {resolveTabLabel(route.path, data.navigation)}
                </TabButton>
            ))}
        </div>
    );
};

export default NavTabs;
